export default function toupper(str) {
    if (!str) return '';
    return str.toUpperCase();
}
